export const IS_SIDEBAR_OPEN_LS = 'text_client.isSidebarOpen';

// Срез layout'а лежит по ключу `${LAYOUT_LS_PREFIX}${projectId}`.
export const LAYOUT_LS_PREFIX = 'text_client.layout.';
